import { getServerTranslation } from '@i18n/getServerTranslation';

type ProductTypeName = {
  products: { productType: { pluralName: string } }[];
  resultCount: number;
};

export default async function getProductTypeName({
  products,
  resultCount
}: ProductTypeName): Promise<string> {
  if (products.length === 0) return '';

  const areAllProductTypesSame = (products: { productType: { pluralName: string } }[]): boolean => {
    const firstProductType = products[0].productType.pluralName;
    return products.every(product => product.productType.pluralName === firstProductType);
  };
  const isSingleResult = resultCount <= 1;

  const { t } = await getServerTranslation('webshop');

  if (areAllProductTypesSame(products)) {
    return isSingleResult ? t('filterPage.productLabel') : products[0].productType.pluralName;
  }
  return isSingleResult ? t('filterPage.productLabel') : t('filterPage.productsLabel');
}
